export default "__VITE_ASSET__CWok2ste__"